export const BASE_DELETE_TRY = 'BASE_DELETE_TRY';
export const BASE_DELETE_OK = 'BASE_DELETE_OK';
export const BASE_DELETE_ERROR = 'BASE_DELETE_ERROR';